import axios from "../../utils/axios";

//
export function settingList(params) {
    return axios({
        url: "/admin/setting/list",
        method: "get",
        params: params
    });
}

//
export function settingSave(data, formName, method = "post") {
    let url =
        formName === "add"
            ? "/admin/setting/add"
            : "/admin/setting/update";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

//
export function settingDelete(data) {
    return axios({
        url: "/admin/setting/delete",
        method: "post",
        data: data
    });
}